<template>
  <v-col
    md="6"
    lg="6"
    sm="6"
    xs="12"
    xl="6"
    :class="`d-flex align-center ${index % 2 ? 'justify-start' : 'justify-end'}`"
  >
    <v-card
      :width="$vuetify.breakpoint.mdAndUp ? '410' : '840'"
      class="fill-height"
      :style="`border-radius: 10px; border: 1px solid rgb(255 255 255 / 0.3); background: linear-gradient(0deg, rgb(255 255 255 / 0.1), rgb(255 255 255 / 0.1)), url(${item.bg}) no-repeat center center / cover;`"
    >
      <v-row class="d-flex flex-column text-center">
        <v-col class="d-flex justify-center" style="padding-top: 27px">
          <v-img contain width="78" height="71" :src="item.src"></v-img>
        </v-col>
        <v-col class="pa-0">
          <span class="h4 white--text">{{ item.title }}</span>
        </v-col>
        <v-col class="px-10 text-center" style="padding-bottom: 35px">
          <span class="text__">{{ item.text }}</span>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "FeatureCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {};
  },
};
</script>
